<div class="filters-bar" [class.client-filters]="role === 'client'">
	<mat-card class="mt-0" id="tag-dropzone-filter" cdkDropList (cdkDropListDropped)="tagsDropAssign.drop($event)">
		<mat-card-content class="p-0">
			<div class="d-flex flex-wrap align-items-center justify-contents-start mx-1">
				<form #filtersFormDirective="ngForm" [formGroup]="filtersFormGroup" class="mt-2 flex-fill d-flex flex-wrap" (submit)="filterListItems()">
					<mat-form-field class="ms-1" [ngClass]="{ 'w-100': role === 'client' }">
						<mat-label>{{ 'CLIPS.MEDIUM_TYPE' | translate }}</mat-label>
						<select id="types" style="display: none"></select>
						<!-- workaround for material-chrome bug -->
						<mat-select id="mediumTypes" formControlName="types" multiple>
							<mat-option #selectAllMediumTypes value="ALL" (click)="mediumTypeSelection()">{{ 'MEDIUM.TYPES.ALL' | translate }}</mat-option>

							@for (clipType of clipTypes; track $index) {
							<mat-option [value]="clipType.id" (click)="mediumTypeSelection($event)">{{ 'MEDIUM.TYPES.' + clipType.id | translate }}</mat-option>
							}
						</mat-select>
					</mat-form-field>

					<mat-form-field class="ms-1" [ngClass]="{ 'w-100': role === 'client' }">
						<mat-date-range-input [rangePicker]="picker" color="primary" [max]="DATE_RANGE_LIMITS.dateTo">
							<input id="dateFrom" formControlName="dateFrom" matStartDate placeholder="{{ 'CLIPS.DATE_FROM' | translate }}" />
							<input id="dateTo" formControlName="dateTo" matEndDate placeholder="{{ 'CLIPS.DATE_TO' | translate }}" [value]="getDateLimitRange()" />
						</mat-date-range-input>
						<mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
						<mat-date-range-picker #picker>
							<mat-date-range-picker-actions>
								<button mat-button matDateRangePickerCancel>{{ 'BUTTON.CANCEL' | translate }}</button>
								<button mat-raised-button color="primary" matDateRangePickerApply>{{ 'BUTTON.APPLY' | translate }}</button>
							</mat-date-range-picker-actions>
						</mat-date-range-picker>
					</mat-form-field>

					<mat-form-field class="ms-1 flex-fill">
						<mat-label>{{ 'BUTTON.SEARCH' | translate }}</mat-label>
						<input matInput formControlName="searchText" placeholder="" />
					</mat-form-field>

					@if (role === 'admin') {
					<mat-form-field class="ms-1 flex-fill reduced-width-field-md">
						<mat-label for="clientId">{{ 'CLIPS.CLIENTS' | translate }}</mat-label>
						<input type="text" matInput formControlName="clientId" [matAutocomplete]="clientAutocomplete" (click)="filtersFormGroup.controls['clientId'].setValue(null)" />
						<mat-autocomplete #clientAutocomplete="matAutocomplete" [displayWith]="displayClientFn.bind(this)">
							@for (filteredItem of filteredClients; track $index) {
							<mat-option [value]="filteredItem">{{ filteredItem.name }}</mat-option>
							}
						</mat-autocomplete>
					</mat-form-field>
					}

					<mat-form-field class="ms-1" [ngClass]="role === 'client' ? 'w-100' : 'reduced-width-field-md'">
						<mat-label for="clip-medium">{{ 'CLIPS.MEDIUM' | translate }}</mat-label>
						<input type="text" matInput formControlName="mediumId" [matAutocomplete]="mediumAutocomplete" />
						<mat-autocomplete #mediumAutocomplete="matAutocomplete" [displayWith]="displayFn.bind(this)">
							@for (filteredItem of filteredMediums; track $index) {
							<mat-option [value]="filteredItem">{{ utils.getParameterByLanguageScript(filteredItem, 'name') }}</mat-option>
							}
						</mat-autocomplete>
					</mat-form-field>

					@if (role === 'client') {
					<mat-form-field class="ms-1" [ngClass]="{ 'w-100': role === 'client' }">
						<mat-label for="clip-author">{{ 'CLIPS.AUTHOR' | translate }}</mat-label>
						<input type="text" matInput formControlName="authorId" [matAutocomplete]="mediumAutocomplete" />
						<mat-autocomplete #mediumAutocomplete="matAutocomplete" [displayWith]="displayAuthorFn.bind(this)">
							@for (filteredItem of filteredAuthors; track $index) {
							<mat-option [value]="filteredItem">{{ utils.getParameterByLanguageScript(filteredItem, 'name') }}</mat-option>
							}
						</mat-autocomplete>
					</mat-form-field>

					@if (hasCompanyTags) {
					<div class="slider-container w-100 ms-1 mb-2">
						<mat-label>{{ 'CLIPS.REACH' | translate }}</mat-label>
						<mat-slider class="w-100" [min]="VISIBILITY_INDEX_RANGE.min" [max]="VISIBILITY_INDEX_RANGE.max" step="1" [disableRipple]="true">
							<input matSliderStartThumb formControlName="visibilityIndexFrom" />
							<input matSliderEndThumb formControlName="visibilityIndexTo" />
						</mat-slider>
						<div class="slider-value-labels">
							<span>{{ filtersFormGroup.controls['visibilityIndexFrom'].value }}</span>
							<span>{{ filtersFormGroup.controls['visibilityIndexTo'].value }}</span>
						</div>
					</div>

					<div class="slider-container w-100 ms-1 mb-2">
						<mat-label>{{ 'CLIPS.INFLUENCE' | translate }}</mat-label>
						<mat-slider class="w-100" [min]="SENTIMENT_SCORE_RANGE.min" [max]="SENTIMENT_SCORE_RANGE.max" step="1" [disableRipple]="true">
							<input matSliderStartThumb formControlName="sentimentScoreFrom" />
							<input matSliderEndThumb formControlName="sentimentScoreTo" />
						</mat-slider>
						<div class="slider-value-labels">
							<span>{{ filtersFormGroup.controls['sentimentScoreFrom'].value }}</span>
							<span>{{ filtersFormGroup.controls['sentimentScoreTo'].value }}</span>
						</div>
						<div class="sentiment-presets">
							<button type="button" class="sentiment-preset positive" [class.active]="isSentimentPresetActive('positive')" (click)="applySentimentPreset('positive')" aria-label="Positive">
								<mat-icon>thumb_up</mat-icon>
							</button>
							<button type="button" class="sentiment-preset neutral" [class.active]="isSentimentPresetActive('neutral')" (click)="applySentimentPreset('neutral')" aria-label="Neutral">
								<mat-icon>remove</mat-icon>
							</button>
							<button type="button" class="sentiment-preset negative" [class.active]="isSentimentPresetActive('negative')" (click)="applySentimentPreset('negative')" aria-label="Negative">
								<mat-icon>thumb_down</mat-icon>
							</button>
						</div>
					</div>
					}
					} @if (role === 'admin') {
					<mat-form-field class="ms-1 flex-fill reduced-width-field-sm wide-panel">
						<mat-label>{{ 'CLIPS.ADDITIONAL_FILTERS' | translate }}</mat-label>
						<select id="flags" style="display: none"></select>
						<!-- workaround for material-chrome bug -->
						<mat-select id="flags" formControlName="flags" panelClass="wide-panel" multiple>
							<mat-option value="noTags">{{ 'CLIPS.SHOW_WITHOUT_TAG' | translate }}</mat-option>
							<mat-option value="onlyTagged">{{ 'CLIPS.HIDE_UNTAGGED' | translate }}</mat-option>
							<mat-option value="autoTagged">{{ 'CLIPS.AUTO_TAGGED' | translate }}</mat-option>
							<mat-option value="autoGrouped">{{ 'CLIPS.AUTO_GROUPED' | translate }}</mat-option>

							<!-- <mat-option value="tagsAll" [disabled]="filtersFormGroup.controls['noTags'].value">{{ 'CLIPS.ALL_TAGS' | translate }}</mat-option>
							<mat-option value="onlyMain" [disabled]="filtersFormGroup.controls['noTags'].value">{{ 'CLIPS.ONLY_MAIN' | translate }}</mat-option> -->
						</mat-select>
					</mat-form-field>
					}

					<div class="ms-1 d-flex mb-1">
						<button
							type="button"
							mat-raised-button
							color="primary"
							class="me-1"
							aria-label="Reset form button"
							matTooltip="{{ 'CLIPS.RESET_FORM' | translate }}"
							matTooltipPosition="below"
							(click)="resetForm(filtersFormDirective)">
							<mat-icon class="m-0">restart_alt</mat-icon>
						</button>

						<button type="submit" mat-raised-button [color]="filtersActive ? 'warn' : 'primary'" class="me-1" aria-label="Filter button" [disabled]="apiLoading">
							@if(apiLoading) {
							<mat-spinner diameter="20"></mat-spinner>
							} @else {
							<span>{{ 'BUTTON.SHOW' | translate }}</span>
							}
						</button>
					</div>
				</form>
			</div>
			<mat-divider class="w-100"></mat-divider>
		</mat-card-content>
	</mat-card>
</div>
